declare namespace $ {

	type $mol_link_source__uri_bog_fragile_demo_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_source['uri'] >
	>
	type $mol_text__text_bog_fragile_demo_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_fragile_demo_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $bog_fragile_demo_case__title_bog_fragile_demo_4 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['title'] >
	>
	type $bog_fragile_demo_case__text_bog_fragile_demo_5 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['text'] >
	>
	type $bog_fragile_demo_case__before_bog_fragile_demo_6 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Outer1'] >
		,
		ReturnType< $bog_fragile_demo_case['before'] >
	>
	type $bog_fragile_demo_case__after_bog_fragile_demo_7 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Outer2'] >
		,
		ReturnType< $bog_fragile_demo_case['after'] >
	>
	type $bog_fragile_demo_case__verdict_bog_fragile_demo_8 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['verdict'] >
	>
	type $mol_text__text_bog_fragile_demo_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $bog_fragile_demo_case__title_bog_fragile_demo_10 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['title'] >
	>
	type $bog_fragile_demo_case__text_bog_fragile_demo_11 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['text'] >
	>
	type $bog_fragile_demo_case__before_bog_fragile_demo_12 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Retype1'] >
		,
		ReturnType< $bog_fragile_demo_case['before'] >
	>
	type $bog_fragile_demo_case__after_bog_fragile_demo_13 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Retype2'] >
		,
		ReturnType< $bog_fragile_demo_case['after'] >
	>
	type $bog_fragile_demo_case__verdict_bog_fragile_demo_14 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['verdict'] >
	>
	type $mol_text__text_bog_fragile_demo_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $bog_fragile_demo_case__title_bog_fragile_demo_16 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['title'] >
	>
	type $bog_fragile_demo_case__text_bog_fragile_demo_17 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['text'] >
	>
	type $bog_fragile_demo_case__before_bog_fragile_demo_18 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Rename_ts1'] >
		,
		ReturnType< $bog_fragile_demo_case['before'] >
	>
	type $bog_fragile_demo_case__after_bog_fragile_demo_19 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Rename_ts2'] >
		,
		ReturnType< $bog_fragile_demo_case['after'] >
	>
	type $bog_fragile_demo_case__verdict_bog_fragile_demo_20 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['verdict'] >
	>
	type $bog_fragile_demo_case__title_bog_fragile_demo_21 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['title'] >
	>
	type $bog_fragile_demo_case__text_bog_fragile_demo_22 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['text'] >
	>
	type $bog_fragile_demo_case__before_bog_fragile_demo_23 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Rename_tree1'] >
		,
		ReturnType< $bog_fragile_demo_case['before'] >
	>
	type $bog_fragile_demo_case__after_bog_fragile_demo_24 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Rename_tree2'] >
		,
		ReturnType< $bog_fragile_demo_case['after'] >
	>
	type $bog_fragile_demo_case__verdict_bog_fragile_demo_25 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['verdict'] >
	>
	type $bog_fragile_demo_case__title_bog_fragile_demo_26 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['title'] >
	>
	type $bog_fragile_demo_case__text_bog_fragile_demo_27 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['text'] >
	>
	type $bog_fragile_demo_case__before_bog_fragile_demo_28 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Collide1'] >
		,
		ReturnType< $bog_fragile_demo_case['before'] >
	>
	type $bog_fragile_demo_case__after_bog_fragile_demo_29 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Collide2'] >
		,
		ReturnType< $bog_fragile_demo_case['after'] >
	>
	type $bog_fragile_demo_case__verdict_bog_fragile_demo_30 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['verdict'] >
	>
	type $bog_fragile_demo_case__title_bog_fragile_demo_31 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['title'] >
	>
	type $bog_fragile_demo_case__text_bog_fragile_demo_32 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['text'] >
	>
	type $bog_fragile_demo_case__before_bog_fragile_demo_33 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Named1'] >
		,
		ReturnType< $bog_fragile_demo_case['before'] >
	>
	type $bog_fragile_demo_case__after_bog_fragile_demo_34 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Named2'] >
		,
		ReturnType< $bog_fragile_demo_case['after'] >
	>
	type $bog_fragile_demo_case__verdict_bog_fragile_demo_35 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['verdict'] >
	>
	type $bog_fragile_demo_case__title_bog_fragile_demo_36 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['title'] >
	>
	type $bog_fragile_demo_case__text_bog_fragile_demo_37 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['text'] >
	>
	type $bog_fragile_demo_case__before_bog_fragile_demo_38 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Plain1'] >
		,
		ReturnType< $bog_fragile_demo_case['before'] >
	>
	type $bog_fragile_demo_case__after_bog_fragile_demo_39 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Plain2'] >
		,
		ReturnType< $bog_fragile_demo_case['after'] >
	>
	type $bog_fragile_demo_case__verdict_bog_fragile_demo_40 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['verdict'] >
	>
	type $bog_fragile_demo_case__title_bog_fragile_demo_41 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['title'] >
	>
	type $bog_fragile_demo_case__text_bog_fragile_demo_42 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['text'] >
	>
	type $bog_fragile_demo_case__before_bog_fragile_demo_43 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Keep1'] >
		,
		ReturnType< $bog_fragile_demo_case['before'] >
	>
	type $bog_fragile_demo_case__after_bog_fragile_demo_44 = $mol_type_enforce<
		ReturnType< $bog_fragile_demo['Keep2'] >
		,
		ReturnType< $bog_fragile_demo_case['after'] >
	>
	type $bog_fragile_demo_case__verdict_bog_fragile_demo_45 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_fragile_demo_case['verdict'] >
	>
	export class $bog_fragile_demo extends $mol_page {
		Source( ): $mol_link_source
		Intro( ): $mol_text
		Outer1( ): $bog_fragile_demo_outer_page1
		Outer2( ): $mol_text
		Outer( ): $bog_fragile_demo_case
		Retype1( ): $bog_fragile_demo_retype_child1
		Retype2( ): $mol_text
		Retype( ): $bog_fragile_demo_case
		Rename_ts1( ): $bog_fragile_demo_rename_heir1
		Rename_ts2( ): $mol_text
		Rename_ts( ): $bog_fragile_demo_case
		Rename_tree1( ): $bog_fragile_demo_rename_heir1
		Rename_tree2( ): $bog_fragile_demo_rename_heir2
		Rename_tree( ): $bog_fragile_demo_case
		Collide1( ): $bog_fragile_demo_collide_child1
		Collide2( ): $bog_fragile_demo_collide_child2
		Collide( ): $bog_fragile_demo_case
		Named1( ): $bog_fragile_demo_collide_named1
		Named2( ): $bog_fragile_demo_collide_named2
		Named( ): $bog_fragile_demo_case
		Plain1( ): $bog_fragile_demo_spread_plain1
		Plain2( ): $bog_fragile_demo_spread_plain2
		Plain( ): $bog_fragile_demo_case
		Keep1( ): $bog_fragile_demo_spread_keep1
		Keep2( ): $bog_fragile_demo_spread_keep2
		Keep( ): $bog_fragile_demo_case
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map